import React from "react";
import { ThaloDataTable } from "@/components/thalo-data-table";
import { Card } from "@/components/ui/card";
import { ColumnDef } from "@tanstack/react-table";
import { InstallationFuelShareEstimate } from "@/meters/meter";
import useMeter from "@/meters/useMeter";

const METER_ASSETS_TABLE_COLUMNS: ColumnDef<InstallationFuelShareEstimate>[] = [
  {
    id: "name",
    accessorFn: (row) => row.installation.name,
    header: "Name",
    cell: ({ row }) => (
      <div className="lg:text-lg truncate text-ellipsis">
        {row.original.installation.name}
      </div>
    ),
  }
]

const MeterAssetsTable = ({ meterId }: { meterId: any }) => {
  const meter = useMeter(meterId);

  return (
    <Card className="px-2">
      <h2 className="text-xl font-barlow font-bold px-4 pt-4">Assets on this meter</h2>
      <ThaloDataTable
        showColumnFilter={false}
        data={meter.data?.data.installation_fuel_share_estimates || []}
        columns={METER_ASSETS_TABLE_COLUMNS}
        isLoading={meter.isPending}
        pageCount={1}
        itemsPerPage={20}
      />
    </Card>
  )
}

export default MeterAssetsTable;
